import React from 'react';
import { connect } from 'react-redux';

import * as fieldsActions from '../../../redux/actions/getFieldsActions';

/*
  Подключает данные из state.Transport.Fields, если их там нет, вызовет action
  filterConnect(Component,['modelsTypes', 'advertisingsTypes', 'appliancesTypes']);
*/
const transportFieldsConnect = (Component, filters) => {
  return connect(
    state => {
      if (Array.isArray(filters)) {
        return filters.reduce((obj, item) => {
          return {
            ...obj,
            [item]: state.Transport.Fields[item],
          };
        }, {});
      }
    },
    dispatch => ({
      getFilterAction: (filters, props) => {
        if (Array.isArray(filters)) {
          filters.forEach(name => {
            if (!props[name]) {
              let actionName = 'get' + name[0].toUpperCase() + name.slice(1);
              if (typeof fieldsActions[actionName] === 'function') {
                dispatch(fieldsActions[actionName]());
              }
            }
          });
        }
      },
    })
  )(
    class extends React.Component {
      componentDidMount() {
        this.props.getFilterAction(filters, this.props);
      }
      render() {
        return <Component {...this.props} />;
      }
    }
  );
};

export default transportFieldsConnect;
